/**
 * Class representing UserService
 * @memberOf services.user
 * @ngdoc service
 * @name UserService
 */

class UserService {
  constructor($http) {

    /**
     * @type {service}
     * @memberOf UserService
     * @description Instance of Angular $http service
     */
    this.http = $http;
  }

  /**
   * @memberOf UserService
   * @description Gets all users in the system
   * @returns {array} Array of all users returned from API
   */
  getAll() {
    return this.http.get('/api/user').then(result => result.data);
  }

  /**
   * @memberOf UserService
   * @param {string} id Id of user in mongo database
   * @description Gets user from API based on id
   * @returns {object} User object returned from API
   */
  getById(id) {
    return this.http.get('/api/user/' + id).then(result => result.data);
  }

  /**
   * @memberOf UserService
   * @param {string} email Email address from user
   * @description Gets user from API based on email address
   * @returns {object} User object returned from API
   */
  getByEmail(email) {
    return this.http.get('/api/user/byEmail/' + email).then(result => result.data);
  }

  /**
   * @memberOf UserService
   * @param {object} user New user object
   * @description Creates a new user by POST to API
   * @returns {object} New user object from API
   */
  create(user) {
    return this.http.post('/api/user/', user).then(result => result.data);
  }

  /**
   * @memberOf UserService
   * @param {string} id Id of user in mongo database
   * @param {user} user User object containing updated information
   * @description Puts user object and id to API to update information
   * @returns {object} User object from API
   */
  update(id, user) {
    return this.http.put('/api/user/' + id, user).then(result => result.data);
  }

  /**
   * @memberOf UserService
   * @param {string} id Id of user in mongo database
   * @description Deletes a user from the backend based on id of user
   * @returns {object} User object from API
   */
  delete(id) {
    return this.http.delete('/api/user/' + id).then(result => result.data);
  }
}

export default angular.module('services.user', [])
  .service('UserService', UserService)
  .name;

UserService.$inject = ['$http'];


// WEBPACK FOOTER //
// ./src/client/app/services/user.service.js